import React, { forwardRef } from 'react';
import get from 'lodash.get';
import { Error, StyledLabel, StyledInput } from './styles';

const CommonComponent = ({ error, reference, ...props }) => {
  return (
    <StyledLabel>
      <StyledInput {...props} ref={reference} />
      {!!error && <Error>{error || 'Field is not valid.'}</Error>}
    </StyledLabel>
  );
};

const ReactHookInput = forwardRef(
  ({ name, type = 'text', placeholder, dataTestSuffix, defaultValue, errors, onChange, onBlur }, ref) => {
    const error = get(errors, name, false);

    return (
      <CommonComponent
        reference={ref}
        onChange={onChange}
        onBlur={onBlur}
        name={name}
        id={name}
        type={type}
        defaultValue={defaultValue}
        placeholder={placeholder}
        isError={!!error}
        data-test={`booking-finalize-${dataTestSuffix}`}
        error={error?.message}
      />
    );
  },
);

const BaseInput = ({ name, type = 'text', label, value = '', error, onChange, onBlur }) => (
  <CommonComponent
    onChange={onChange}
    onBlur={onBlur}
    name={name}
    id={name}
    type={type}
    value={value}
    placeholder={label}
    isError={!!error}
    error={error}
  />
);

export { ReactHookInput, BaseInput };
